import customerConfig from '@/modules/customer/config'
import config from '@/config'
import * as _ from 'lodash'
import request from '@/modules/base/util/request'

/*
 * Actions
 */
const START_FETCHING_STATS_DATA = 'orgamax/customer/sales/START_FETCHING_STATS_DATA'
const FINISHED_FETCHING_STATS_DATA = 'orgamax/customer/sales/FINISHED_FETCHING_STATS_DATA'
const ERROR_FETCHING_STATS_DATA = 'orgamax/customer/sales/ERROR_FETCHING_STATS_DATA'

/*
 * Reducer
 */
const initialState = {
  errorOccurred: false,
  chartData: {},
  statsData: {},
}

export default function reducer(state = initialState, action) {
  const { chartData, statsData } = action
  let parsedChartData = null

  switch (action.type) {
    case START_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        isLoading: true,
        isLoadingAdditionalStats: false,
      })

    case FINISHED_FETCHING_STATS_DATA:
      parsedChartData = parseChartData(chartData)

      return Object.assign({}, state, {
        chartData: parsedChartData,
        statsData,
        errorOccurred: false,
      })

    case ERROR_FETCHING_STATS_DATA:
      return Object.assign({}, state, {
        errorOccurred: true,
      })

    default:
      return state
  }
}

/*
 * Action Creators
 */
const startFetchingStatsData = () => {
  return {
    type: START_FETCHING_STATS_DATA,
  }
}

const finishedFetchingStatsData = (data) => {
  const { chartData, ...statsData } = data
  return {
    type: FINISHED_FETCHING_STATS_DATA,
    chartData,
    statsData,
  }
}

const errorFetchingStatsData = () => {
  return {
    type: ERROR_FETCHING_STATS_DATA,
  }
}

const parseChartData = data => {
  const reduceArraySize = () => {
    if (data?.length > 6) {
      data.shift()
      reduceArraySize()
    }
  }
  if (data?.length > 6) {
    reduceArraySize()
  }

  const chartData = {
    labels: [],
    series: [],
    headerYearLabel: '',
    prevDataExist: data.prevDataExist,
    nextDataExist: data.nextDataExist,
  }

  const monthOrder = _.map(data, 'month')

  const monthLabels = monthOrder.map(item => config.monthNames[item - 1])
  chartData.labels = monthLabels

  chartData.series = [
    {
      data: _.map(data, item => {
        const meta = `${item.month}/${item.year}`
        return {
          meta,
          value: item.sales,
        }
      }),
      name: 'sales',
    },
  ]

  const chartYears = data
    .map(salesObj => salesObj.year)

  chartData.headerYearLabel = _.uniq(chartYears).join('/')

  return chartData
}

export const fetchStatsData = (id) => {
  return dispatch => {
    dispatch(startFetchingStatsData())

    request(`${customerConfig.resourceUrl}/${id}/statistics`, {
      auth: true,
      isConcurrent: true,
    })
      .then(({ body: { data } }) => {
        dispatch(
          finishedFetchingStatsData(data),
        )
      })
      .catch(() => {
        dispatch(errorFetchingStatsData())
      })
  }
}
